import { render, staticRenderFns } from "./newadd.vue?vue&type=template&id=7351a6c4&scoped=true&"
import script from "./newadd.vue?vue&type=script&lang=js&"
export * from "./newadd.vue?vue&type=script&lang=js&"
import style0 from "./newadd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newadd.vue?vue&type=style&index=1&id=7351a6c4&leng=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7351a6c4",
  null
  
)

export default component.exports